import type { ComponentType } from 'react';

/**
 * Things a feature puts in the top bar, beside search and the connection pill (the
 * notification bell). Each feature adds src/features/<area>/TopBarItem.tsx that
 * default-exports a TopBarItem; the top bar finds them, so no shared list needs editing.
 */
export interface TopBarItem {
  id: string;
  /** Lower comes first (further left). */
  order: number;
  Component: ComponentType;
}

const modules = import.meta.glob<{ default: TopBarItem }>('../../features/*/TopBarItem.tsx', { eager: true });

export const TOP_BAR_ITEMS: TopBarItem[] = Object.values(modules)
  .map((m) => m.default)
  .filter(Boolean)
  .sort((a, b) => a.order - b.order);
